import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';

import RelatedNewsEventsContext from '../context/RelatedNewsEventsContext';

const sortByDate = (arr) => {
  arr.sort((a, b) => {
    let dateA = a.dateDiff;
    let dateB = b.dateDiff;
    if (a.dateDiff === b.dateDiff) {
      return -1;
    }
    return dateB - dateA;
  });

  return arr.reverse();
};

export default class RelatedNewsEventsContainer extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      ready: false,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData('initial');
  }

  async fetchData(type) {
    const reactRoot = document.getElementById('react-root');
    const tagProviderId =  reactRoot.getAttribute('data-tag-provider-id');

    const apiEventsFuture = `/api/future_events/tagged?_format=json&tag_provider_id=${tagProviderId}`;
    // const apiEventsFuture = `/api/future_events?_format=json`;
    const apiNews = `/api/news/tagged?_format=json&tag_provider_id=${tagProviderId}`;
    // const apiNews = `/api/news?_format=json`;
    const apiTerms = '/api/terms?_format=json';


    if (type === 'initial') {
      try {
        const fetchNews = await fetch(apiNews);
        const fetchEventsFuture = await fetch(apiEventsFuture);

        if (!fetchNews.ok) {
          throw Error(fetchNews.statusText);
        }
        if (!fetchEventsFuture.ok) {
          throw Error(fetchEventsFuture.statusText);
        }

        const news = await fetchNews.json();
        const eventsFuture = await fetchEventsFuture.json();
        const fetchTerms = await fetch(apiTerms);
        const newsEvents = news.concat(eventsFuture);
        const sortedNewsEvents = sortByDate(newsEvents);
        const threeSortedNewsEvents = sortedNewsEvents.slice(0, 3)
        const terms = await fetchTerms.json();

        this.setState({
          data: threeSortedNewsEvents,
          ready: true,
          terms,
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  render() {
    const { ready } = this.state;
    const { children } = this.props;

    if(!ready || ready && this.state.data.length === 0) return null;

    return (
      <RelatedNewsEventsContext.Provider value={this.state}>
        {children}
      </RelatedNewsEventsContext.Provider>
    );
  }
}

RelatedNewsEventsContainer.propTypes = {
  children: PropTypes.shape({}).isRequired,
};
